let scrollPos = 0;
let scrollPosSticky = 0;
const scrollPosHidden = 350;
const body = document.querySelector('body');
const isStickyTopPresent = document.querySelector('.rn-sticky-top') !== null;
const isNavContainerStickyPresent = document.querySelector('.rn-component-nav-container-sticky') !== null;
const isStickyBehaviorEnabled = isNavContainerStickyPresent || isStickyTopPresent;
const headerEl = document.querySelector('.header');
const style = getComputedStyle(document.documentElement);
function checkPosition() {
    const windowY = window.scrollY;
    const scrollPosSticky = style.getPropertyValue('--headeroffset');

    if (windowY < parseInt(scrollPosSticky)) {
        body.classList.remove('is-sticky');
        if (!body.classList.contains('dtbbooking')) headerEl.classList.add('invert-btns');
    } else {
        body.classList.add('is-sticky');
        if (!body.classList.contains('dtbbooking')) headerEl.classList.remove('invert-btns');
    }

    // Update 'is-hidden' class based on scrollPos and scrollPosHidden
    // Disable showing menu on scroll up if either sticky class is present
    if (windowY >= scrollPosHidden && windowY > scrollPos) {
        body.classList.add('is-hidden');
    } else if (!isStickyBehaviorEnabled || windowY <= scrollPosHidden) {
        body.classList.remove('is-hidden');
    }

    // Update the scroll position
    scrollPos = windowY;
}

if (headerEl) {
    checkPosition();
    window.addEventListener('scroll', checkPosition);
}
